import { cameraIcon } from "@/lib/icons";
import { pictureIcon } from "@/lib/icons";
import Link from "next/link";

export default function SearchToggle({ display, galleriesSelected, photosSelected }) {
  return (<div className='lexcms-search-toggle-container'>
    { display == 'application_photos_only' &&
      <Link href='/lex-cms/inspiration/application_photos/index'>
        <a className="lexcms-inspiration-view-all-button lexcms-regular-button">
          { cameraIcon }<span>View All Photos</span>
        </a>
      </Link>
      }
    { display == 'galleries_only' &&
      <Link href='/lex-cms/inspiration/galleries/index'>
        <a className="lexcms-inspiration-view-all-button lexcms-regular-button">
          { pictureIcon }<span>View All Galleries</span>
        </a>
      </Link>
      }
      { display == 'both_application_photos_and_galleries' &&
      <div className='lexcms-photo-gallery-toggle' >
        <Link href='/lex-cms/inspiration/galleries/index'>
          <div className='toggle-radio-container'>
            <input type='radio' id='show_galleries_radio' checked={galleriesSelected} readOnly /> 
            <label htmlFor='show_galleries_radio'>{ pictureIcon }<span>Search All Galleries</span></label>
          </div>
        </Link>
        <Link href='/lex-cms/inspiration/application_photos/index'>
          <div className='toggle-radio-container'>
            <input type='radio' id='show_photos_radio' checked={photosSelected} readOnly /> 
            <label htmlFor='show_photos_radio'>{ cameraIcon }<span>Search All Photos</span></label> 
          </div>
        </Link>
      </div>
      }
  </div>
  )
} 